import { IGuaranteeApplication } from './../interfaces/guarantee/guarantee';
import { ResponseType } from 'axios';
import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { DTO } from './base.dto';

export class CheckGuarantorInvitation extends DTO {
	public param: undefined;
	public query: { mortgageId: string; email: string };
	public body: undefined;
	public url: string = ENDPOINT.GUARANTOR_CHECK_INVITATION;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(query: { mortgageId: string; email: string }) {
		super();
		this.query = query;
	}
}

export class GetGuarantorDealInfo extends DTO {
	public param: { mortgageId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.GUARANTOR_GET_DEAL_DETAIL;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { mortgageId: string }) {
		super();
		this.param = param;
	}
}

export class GuarantorInvitationAction extends DTO {
	public param: undefined;
	public query: undefined;
	public body: { mortgageId: string };
	public url: string = ENDPOINT.GUARANTOR_GET_DEAL_DETAIL;
	public method: HTTP_METHOD = HTTP_METHOD.PUT;
	public readonly responseType: ResponseType = 'json';
	constructor(body: { mortgageId: string }, url: string) {
		super();
		this.url = url;
		this.body = body;
	}
}

export class GetGuaranteeListDTO extends DTO {
	public param: undefined;
	public query: IGuaranteeApplication;
	public body: undefined;
	public url: string = ENDPOINT.GET_GUARANTEE_LIST;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(query: IGuaranteeApplication) {
		super();
		this.query = query;
	}
}
export class ConfirmGuarantorInvitation extends DTO {
	public param: undefined;
	public query: { mortgageId: string; email: string };
	public body: undefined;
	public url: string = ENDPOINT.GUARANTOR_CONFIRM_INVITATION;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(query: { mortgageId: string; email: string }) {
		super();
		this.query = query;
	}
}
